import { render, staticRenderFns } from "./TagsDecorations.vue?vue&type=template&id=3c35fd95&name=tags-decorations&"
import script from "./TagsDecorations.vue?vue&type=script&lang=js&"
export * from "./TagsDecorations.vue?vue&type=script&lang=js&"
import style0 from "./TagsDecorations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports